import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.scss']
})
export class PasswordDialogComponent implements OnInit {
  invalid = false;
  password: FormControl;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { text: string; error: string; pw: string },
    private dialogRef: MatDialogRef<PasswordDialogComponent>
  ) {}

  ngOnInit(): void {
    this.password = new FormControl('', [Validators.required]);
  }

  onOkay() {
    this.password.value === this.data.pw ? this.dialogRef.close() : (this.invalid = true);
  }
}
